<template>
  <div class="wx-pay-success-overlay">
    <van-overlay
      :show="value"
    >
      <van-icon
        name="cross"
        class="close"
        @click="$emit('change', false)"
      />
      <div class="pay-operating-wrapper">
        <p class="title">请确认微信支付是否完成</p>
        <van-button class="button success-button" @click="successHandler">已完成支付</van-button>
        <van-button class="button reset-button" @click="resetHandler">支付遇到问题,重新支付</van-button>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: 'WxPaySuccessOverlay',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    successHandler () {
      this.$emit('change', false)
      this.$emit('success')
    },
    resetHandler () {
      this.$emit('change', false)
      this.$emit('reset')
    }
  }
}
</script>

<style scoped lang="scss">
.wx-pay-success-overlay {
  position: relative;
  .close {
    @include sc(28px, $color-text-light);
    position: absolute;
    top: 16px;
    right: 16px;
  }
  .pay-operating-wrapper {
    @include wh(80%, initial);
    margin: 200px auto;
    padding: 20px;
    text-align: center;
    border-radius: 8px;
    background-color: #fff;
    .title {
      @include sc($font-size-lg, $color-text-heavy);
      @include lw(initial, 500);
      padding-bottom: 20px;
    }
    .button {
      font-size: $font-size-lg;
      & + .button {
        margin-top: 10px;
      }
      &.success-button {
        @include normal-button(100%, 39px);
        @include lg-radius(#E6AC67, #F5C993, 4px);
      }
      &.reset-button {
        @include plain-button(100%, 39px);
      }
    }
  }
}
</style>
